import { FC, useEffect, useMemo } from "react";
import { Box, Stack, useTheme } from "@mui/material";
import { createHeatmap, legend } from "utils";
import getStyles from "./styles";

interface IProps {
  id: string;
  width: number;
  data: any;
  ptsX: any;
  ptsY: any;
  dimX: any;
  dimY: any;
  maxValue: any;
  maxValue_left: any;
  maxValue_right: any;
  updatedHeight: any;
  disableXAxis: boolean;
  scale: any;
  legendTitle: string;
  heatmapTitle?: string;
  ypos?: string;
}

const Heatmap: FC<IProps> = ({
  id,
  width,
  data,
  ptsX,
  ptsY,
  dimX,
  dimY,
  maxValue,
  maxValue_left,
  maxValue_right,
  updatedHeight,
  disableXAxis,
  scale,
  legendTitle,
  heatmapTitle,
  ypos,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).Heatmap, [theme]);
  console.log("divId", id);

  useEffect(() => {
    createHeatmap(
      id,
      width,
      data,
      ptsX,
      ptsY,
      dimX,
      dimY,
      Math.max(...[maxValue, maxValue_left, maxValue_right]),
      updatedHeight,
      disableXAxis,
      scale,
      heatmapTitle,
      ypos
    );
    legend(`heatmaproot-legend-${id}`, legendTitle, scale);
  });

  return (
    <Stack sx={styles.container}>
      <Box id={id} sx={styles.heatmap} />
      <Box component="svg" id={`heatmaproot-legend-${id}`} sx={styles.legend} />
    </Stack>
  );
};

export default Heatmap;
